import BaseStaticPage from '../BaseStaticPage';
import { isEmptyList, isEmptyString, merge } from '../../../utils';
import baseStaticStyles from '../BaseStaticPage/styles';
import React from 'react';
import Parser from 'react-html-parser';
import { withResizer } from '../../../HoCs';
import styles from './styles';
import WhyJoinOyo from '../../../ui-components/WhyJoinOyoStrip/components/Card';
import ReactHtmlParser from 'react-html-parser';
import { EVENT_ACTIONS, EVENT_CATEGORIES, logEvent } from '../../../services/Analytics';
import ButtonBase from '@material-ui/core/ButtonBase';
import { guc } from '../../../services/Localisation';

class Referral extends BaseStaticPage {
    
    styles = merge(baseStaticStyles, styles);
    content_json_key = 'referral_json';
    state = this.parseJsonString();
    footerLinks = [
        { content: guc('partner_page'), href: '/', event_action: EVENT_ACTIONS.HOME_PAGE_LINK_CLICKED },
        { content: guc('terms_and_conditions'), href: this.state.data.tandc_link, target: '_blank', event_action: EVENT_ACTIONS.TNC_CLICKED }
    ];
    
    onTncClicked = () => logEvent(EVENT_CATEGORIES.UK_REFERRAL_PAGE, EVENT_ACTIONS.TNC_SECTION_CLICKED);
    
    onRightCardTnClicked = () => logEvent(EVENT_CATEGORIES.UK_REFERRAL_PAGE, EVENT_ACTIONS.HEADER_TNC_CLICKED);
    
    onGetStartedClicked = () => logEvent(EVENT_CATEGORIES.UK_REFERRAL_PAGE, EVENT_ACTIONS.GET_STARTED_CLICKED);
    
    renderCards = projects => <div style={this.gs('tab_cards')}>
        <div style={this.gs('tab_cards_padding')} />
        {projects.map(({ title, image, description, highlight_color }, index) =>
            <WhyJoinOyo key={index} title={Parser(title)} image={image} description={Parser(description)} style={this.gs('tab_card')} />
        )}
        <div style={this.gs('tab_cards_padding')} />
    </div>
    
    renderImage = () => {
        const { image, rcard_title, rcard_content, survey_link, get_started, tandc_link, t_amp_c, image_text_style } = this.state.data;
        return <div style={merge(this.gs('image_containter'), { backgroundImage: `url(${image})` })}>
            <div style={merge(this.gs('right_card'), this.gs('right_card_override'), image_text_style)}>
                <div style={this.gs('left_card_heading')}>{rcard_title}</div>
                <div style={{ marginTop: 12 }}>{rcard_content}{'('}
                <a href={tandc_link} onClick={this.onRightCardTnClicked} target='_blank' style={this.gs('tandc_link_in_card')}>{t_amp_c}</a>
                    {')'}
                </div>
                <a href={survey_link} onClick={this.onGetStartedClicked} target='_blank'><ButtonBase style={this.gs('start_button')}>{get_started}</ButtonBase></a>
            </div>
        </div>;
    }
    
    renderTabContent = () => {
        const { tabs } = this.state.data;
        return <>
            {!isEmptyList(tabs) && tabs.map(({ id, heading, message, footing, projects }, index) => <div key={id} style={merge(this.gs('tab_content'), index % 2 && this.gs('tab_content_back'))}>
                {!isEmptyString(heading) && <div style={this.gs('tab_heading')}>{Parser(heading)}</div>}
                {!isEmptyString(message) && <div style={this.gs('tab_message')}>{Parser(message)}</div>}
                {!isEmptyList(projects) && this.renderCards(projects)}
                {!isEmptyString(footing) && <div style={this.gs('tab_footing')}>{Parser(footing)}</div>}
            </div>)}
        </>;
    }
    
    renderTermsAndConditions = () => {
        const { tandc_link, tandc_heading, Click, here, for_detailed_terms_and_conditions, tandc_list } = this.state.data;
        return <div style={this.gs('tandc_container')}>
            <div style={this.gs('tandc_title')}>{tandc_heading}</div>
            <ol style={this.gs('tandc_ol')}>
                {!isEmptyList(tandc_list) && tandc_list.map((tandc, i) => <li key={i} style={this.gs('tandc')}>{ReactHtmlParser(tandc)}</li>)}
                <div style={this.gs('tandc_text_in_card')}>{Click} <a href={tandc_link} onClick={this.onTncClicked} target='_blank' style={this.gs('tandc_link_in_card')}>{here}</a> {for_detailed_terms_and_conditions}.</div>
            </ol>
        </div>;
    }
    
    renderContent = () =>
        <>
            {this.renderTabContent()}
            {this.renderTermsAndConditions()}
        </>
}

export default withResizer(Referral);
